var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1329,
    height: 960,
    viewBox: "0 0 1329 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-332.498 -112.755C-334.36 -105.471 -334.512 9.51447 -332.835 142.769C-329.527 404.958 -329.776 402.281 -299.128 504.29C-257.429 643.084 -149.689 790.829 -26.4261 878.242C0.776611 897.535 65.2644 937.665 69.0619 937.665C70.2006 937.665 83.1618 945.207 97.8726 954.425C112.578 963.643 125.716 971.185 127.069 971.185C128.418 971.185 155.015 986.27 186.172 1004.71C217.328 1023.14 243.754 1038.23 244.902 1038.23C246.046 1038.23 263.723 1047.92 284.182 1059.78C304.64 1071.63 321.848 1081.32 322.42 1081.32C322.992 1081.32 345.352 1093.18 372.11 1107.66C398.868 1122.15 422.409 1134 424.428 1134C430.014 1134 428.699 708.608 422.908 643.161C406.75 460.512 305.612 279.686 151.96 158.734C107.129 123.442 -18.4402 47.2012 -168.158 -35.6284C-177.566 -40.8337 -199.559 -53.2316 -217.031 -63.1777C-234.503 -73.1237 -259.795 -87.1544 -273.235 -94.3566C-286.675 -101.559 -304.743 -111.625 -313.389 -116.725L-329.107 -126L-332.498 -112.755Z",
    fill: "url(#paint0_linear_505_63552)",
    fillOpacity: 0.23
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1327.83 417.302C1329.28 422.967 1329.4 512.4 1328.09 616.042C1325.52 819.967 1325.71 817.885 1301.86 897.225C1269.41 1005.18 1185.57 1120.09 1089.64 1188.08C1068.47 1203.08 1018.29 1234.29 1015.33 1234.29C1014.44 1234.29 1004.36 1240.16 992.91 1247.33C981.466 1254.5 971.242 1260.37 970.189 1260.37C969.139 1260.37 948.441 1272.1 924.195 1286.44C899.948 1300.78 879.383 1312.51 878.489 1312.51C877.599 1312.51 863.843 1320.05 847.922 1329.27C832.001 1338.49 818.609 1346.03 818.164 1346.03C817.719 1346.03 800.318 1355.25 779.495 1366.52C758.671 1377.78 740.351 1387 738.78 1387C734.433 1387 735.456 1056.14 739.963 1005.24C752.537 863.176 831.244 722.534 950.818 628.46C985.707 601.01 1083.43 541.712 1199.94 477.289C1207.26 473.24 1224.38 463.598 1237.97 455.862C1251.57 448.126 1271.25 437.213 1281.71 431.612C1292.17 426.01 1306.23 418.181 1312.96 414.214L1325.19 407L1327.83 417.302Z",
    fill: "url(#paint1_linear_505_63552)",
    fillOpacity: 0.23
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_505_63552",
    x1: 47,
    y1: -126,
    x2: 47,
    y2: 1134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_505_63552",
    x1: 1032.5,
    y1: 407,
    x2: 1032.5,
    y2: 1387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.c0dbee6905392aca9945304fff67b210.svg";
export { ForwardRef as ReactComponent };